module.exports = __webpack_public_path__ + "static/media/img1.3ddbff3a.png";